import { Configuration, PopupRequest } from "@azure/msal-browser";

// Environment-driven auth settings.
// Dev/QA keep existing defaults; Prod can override via build env vars.
const tenantId = process.env.REACT_APP_AAD_TENANT_ID || "254ba93e-1f6f-48f3-90e6-e2766664b477";
const spaClientId = process.env.REACT_APP_AAD_CLIENT_ID || "f71dfec3-8146-4229-ab15-a89e86dbb8f4";
const apiAppId = process.env.REACT_APP_API_APP_ID || "f71dfec3-8146-4229-ab15-a89e86dbb8f4";

/**
 * Configuration object to be passed to MSAL instance on creation.
 * For a full list of MSAL.js configuration parameters, visit:
 * https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-browser/docs/configuration.md
 */
export const msalConfig: Configuration = {
  auth: {
    clientId: spaClientId, // SPA Application (client) ID
    authority: `https://login.microsoftonline.com/${tenantId}`,
    redirectUri: `${window.location.origin}/`,
    postLogoutRedirectUri: `${window.location.origin}/`,
    navigateToLoginRequestUrl: false,
  },
  cache: {
    cacheLocation: "sessionStorage", // This configures where your cache will be stored
    storeAuthStateInCookie: false, // Set this to "true" if you are having issues on IE11 or Edge
  },
};

/**
 * Scopes you add here will be prompted for user consent during sign-in.
 * By default, MSAL.js will add OIDC scopes (openid, profile, email) to any login request.
 * For more information about OIDC scopes, visit:
 * https://docs.microsoft.com/en-us/azure/active-directory/develop/v2-permissions-and-consent#openid-connect-scopes
 */
export const loginRequest: PopupRequest = {
  // Use basic OIDC scopes for authentication - these always work
  // Access tokens for API calls are acquired separately in getAccessToken()
  scopes: ["openid", "profile", "email"],
};

/**
 * API scopes for acquiring access tokens to call the backend API
 * These are separate from login scopes - login uses OIDC scopes for authentication,
 * while API calls need access tokens with the correct audience
 */
export const apiScopes = [
  `api://${apiAppId}/user_impersonation`, // Preferred delegated scope for SPA user flows
  `${apiAppId}/.default`, // Primary: GUID/.default
  `api://${apiAppId}/.default`, // Fallback: api://GUID/.default
];

/**
 * Add here the endpoints and scopes when obtaining an access token for protected web APIs. For more information, see:
 * https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-browser/docs/resources-and-scopes.md
 */
export const graphConfig = {
  graphMeEndpoint: "https://graph.microsoft.com/v1.0/me",
};

